import { useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
const useDealXGData = (showNdsWithDeal, dealXgData, paymentsInfo, updatePaymentsInfo, udsLocalStateValues) => {
  const {
    activeTab,
    selectedCreditTier,
    financeDownPayment,
    localInterestRate,
    vehicleCondition = 'used',
    selectedLoanTerm,
    selectedLeaseTerm,
    selectedMileage,
    localTradeInValue,
    localAmountOwed
  } = udsLocalStateValues || {};
  useEffect(() => {
    if (showNdsWithDeal && !_isEmpty(dealXgData)) {
      const {
        deal,
        tradeIn: dealXgTradeIn
      } = dealXgData;
      const {
        creditRating,
        dealType: dealXgDealType,
        downPayment: dealXgDownPayment,
        leaseMileageRange: dealXgLeaseMileageRange,
        leaseTerm: dealXgLeaseTerm,
        loanTerm: dealXgLoanTerm,
        rate
      } = deal;
      const {
        tradeSubmitFlag,
        totalAllowance,
        totalPayoff,
        netTrade
      } = dealXgTradeIn;
      const dealTypeWithFallback = activeTab ?? dealXgDealType.toLowerCase();
      const updatedPaymentsInfo = {
        ...paymentsInfo,
        creditType: creditRating ?? selectedCreditTier,
        dealType: dealTypeWithFallback,
        downPayment: dealXgDownPayment ?? financeDownPayment,
        interestRate: {
          [vehicleCondition?.toLowerCase()]: rate ?? localInterestRate
        },
        loanTerm: dealXgLoanTerm ?? selectedLoanTerm,
        tradeIn: {
          value: localTradeInValue,
          amountOwed: localAmountOwed,
          condition: vehicleCondition,
          netTrade,
          totalAllowance,
          totalPayoff,
          tradeSubmitFlag
        },
        interactions: {
          ...paymentsInfo.interactions,
          fromNds: true
        }
      };
      if (dealTypeWithFallback === 'Lease') {
        updatedPaymentsInfo.leaseMileageRange = dealXgLeaseMileageRange ?? selectedMileage;
        updatedPaymentsInfo.leaseTerm = dealXgLeaseTerm ?? selectedLeaseTerm;
      }
      updatePaymentsInfo(updatedPaymentsInfo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showNdsWithDeal]);
};
export { useDealXGData as default };
